var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$translate("title")))]), _c('template', {
    slot: "content"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.name,
      "label": _vm.$translate('labels.name'),
      "dense": "",
      "autofocus": "",
      "required": "",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.operator.name,
      callback: function callback($$v) {
        _vm.$set(_vm.operator, "name", $$v);
      },
      expression: "operator.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.legal_name,
      "label": _vm.$translate('labels.legal_name'),
      "dense": "",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.operator.legal_name,
      callback: function callback($$v) {
        _vm.$set(_vm.operator, "legal_name", $$v);
      },
      expression: "operator.legal_name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.siren,
      "label": _vm.$translate('labels.siren'),
      "dense": "",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.operator.siren,
      callback: function callback($$v) {
        _vm.$set(_vm.operator, "siren", $$v);
      },
      expression: "operator.siren"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.errors.vat_number,
      "label": _vm.$translate('labels.vat_number'),
      "dense": "",
      "outlined": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.operator.vat_number,
      callback: function callback($$v) {
        _vm.$set(_vm.operator, "vat_number", $$v);
      },
      expression: "operator.vat_number"
    }
  })], 1)], 1), _c('AddressForm', {
    staticClass: "mt-2",
    attrs: {
      "title": _vm.$translate('labels.address'),
      "errors": _vm.errors.billing_address,
      "highlight-mandatory": true
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.operator.billing_address,
      callback: function callback($$v) {
        _vm.$set(_vm.operator, "billing_address", $$v);
      },
      expression: "operator.billing_address"
    }
  })], 1), _c('template', {
    slot: "bottom"
  }, [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('buttons.cancel'),
      "ghost": ""
    },
    on: {
      "click": _vm.cancelClicked
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.$translate('buttons.save'),
      "loading": _vm.saving
    },
    on: {
      "click": _vm.saveClicked
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }